<template lang="pug">
  div.indexBox
     div.headBox
        div.backInfoBox
        div.carInfoBox(:style="{'backgroundImage': 'url(' + backUrl + ')'}")
            div.carImg
              div.userImgBox 
                  img.userImg(src='https://img.zcool.cn/community/0171ee5d4d56c7a80120695ced27e7.jpg@160w_160h_1c_1e_1o_100sh.jpg')
            div.carInfo
              div.info 会员姓名：{{cards[nowCardIndex]?cards[nowCardIndex].userName:''}}
              div.info 卡属门店：{{cards[nowCardIndex]?cards[nowCardIndex].orgName:''}}
              div.info 开卡时间：{{cards[nowCardIndex]?(cards[nowCardIndex].openDate?cards[nowCardIndex].openDate.substr(0,10):''):''}}
              div.info 会员卡号：{{cards[nowCardIndex]?cards[nowCardIndex].cardNo:''}}
            div.switchBox(@click='showCard()' v-if="cards.length>1")
              svgIcon(iconStyle='style' iconClass='switch')
        div.showMsgInfo(v-if='show') 
            div.msgContent 该店铺还未开通手机查询，请联系相应门店申请开通方可查询      
        div.statiBox(:class="show?'filter':''")
            van-overlay.vanOverlay(:show="show") 
            div.title 我的资产
            div.content
                div.statiItem
                   div.name 累计购买次卡
                   div.value {{priceInfo.addTcard}}元 
                div.statiItem
                   div.name 累计充值
                   div.value {{priceInfo.recharge}}元
                div.statiItem
                   div.name 累计下卡
                   div.value {{priceInfo.pay}}元
                div.statiItem
                   div.name 累计积分
                   div.value {{cards[nowCardIndex]?cards[nowCardIndex].totalPointsIn:''}}
     div.payOutBox(:class="show?'filter':''")
        van-overlay.vanOverlay(:show="show")
        div.title 最近消费
        div.payOutItem(v-for='item in businessList')
            div.payOutLeft
               div.text {{item.orgName}}：消费{{item.realAmount}}元：{{item.proName}}
               div.time {{item.createTime}}
            div.payOutRight(@click='toPayItem(item)')
               div {{item.businessName}}详情
               van-icon(name="arrow" style="line-height: inherit;padding:3px 0 0 3px;")
     div.payOutShopBox(:class="show?'filter':''")
        van-overlay.vanOverlay(:show="show")
        div.title 消费门店 
        div.content
          div.shopInfo(v-for='item in orgList' @click='toShopInfo(item)' :class="(orgList.length)<=3?'shopInfo_'+(orgList.length)%3:''")
            div.name {{item.ORGNAME}}
            div.value 店基础信息查询
     div.descBox
        div.descItem 版权归美安软件所有，技术支持QQ：504503200
        div.descItem 售后热线：18980811900（同微信）
     van-dialog(v-model='digShow' title='请选择会员卡' :showConfirmButton='false' :closeOnClickOverlay='true')
        div.digTagBox
          van-cell-group
              van-cell.digTagInfo(v-for='(item, index) in cards' :key='index' :value="item.userName+'【'+item.cardNo+'】'" clickable @click='selectCard(index)' :class="{'card-selected':nowCardIndex == index}") 
     div.logOutBox
        van-button.logOutBtn(size='large' text='退出登录' @click='logOut')          
</template>

<script>
  import { Button, Toast, Icon, Cell, CellGroup, Dialog, Overlay } from 'vant';
  import svgIcon from './common/icon';
  import { mapGetters, mapMutations } from 'vuex';
  import config from '../config';
  import Vue from 'vue';
  Vue.use(Dialog);

  export default {
    components: {
      'svgIcon':svgIcon,
      [Button.name]: Button,
      [Toast.name]: Toast,
      [Icon.name]: Icon,
      [CellGroup.name]: CellGroup,
      [Cell.name]: Cell,
      [Dialog.name]: Dialog,
      [Overlay.name]: Overlay
    },
    name: 'login',
    created() {
        this.checksub();
    },
    computed: {
      ...mapGetters([
        'viewParams',
        'openId'
      ])
    },
    data() {
      return {
        backUrl: require('../assets/img/indexBack.png'),
        cards:[],
        digShow: false,
        nowCardIndex: 0,
        priceInfo:{},
        businessList:[],
        orgList:[],
        types:{
          'cash':'现金',
          'card':'储值卡'
        },
        appId:'',
        code:'',
        orgId:'',
        show: false
      };
    },
    watch:{
      nowCardIndex(curVal){
        this.show = this.cards[curVal].property != 'unit'
      }
    },
    methods:{
      toShopInfo(item){
          this.setTransition('move-left');
          this.saveViewParams({'shopInfo':item,'customerInfo':this.cards[this.nowCardIndex]});
          this.$router.push('/shopInfo');
      },
      initCardInfo(status){
        this.$http.post('/card/getInfo', {}).then((response) => {
            if (response.data.success) {
                this.cards = response.data.content;
                if(!this.cards){
                  Toast("未找到相关信息");
                }else{
                  if(this.$route.query.nowCardIndex && this.$route.query.nowCardIndex > 0){
                    this.nowCardIndex = this.$route.query.nowCardIndex;
                  }else{
                    if(this.cards.length>1){
                      this.digShow = true;
                    }
                  }

                  //判断是否需要授权
                  if(!this.openId){
                    if(!this.$route.query.code || !status){
                      this.getAppId();
                    }else{
                      this.code = this.$route.query.code;
                      this.getOpenId();
                    }
                  }

                  this.recharge();
                  this.showBusinessList();
                  this.showOrgList();
                }
            }else{
              Toast(response.data.errorMessage);
            }
        });
      },
      recharge(){
        this.$http.post('/business/recharge', {'customerId':this.cards[this.nowCardIndex].fkCustomerId}).then((response) => {
            if (response.data.success) {
                this.priceInfo = response.data.content;
            }else{
              Toast(response.data.errorMessage);
            }
        });
      },
      showBusinessList(){
        Toast.loading({
            duration: 0,
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner'
        });
        this.$http.post('/business/showBusinessList', {'customerId':this.cards[this.nowCardIndex].fkCustomerId}).then((response) => {
            Toast.clear();
            if (response.data.success) {
                this.businessList = response.data.content.records;
            }else{
              Toast(response.data.errorMessage);
            }
        });
      },
      showOrgList(){
        this.$http.post('/business/selectOrgList', {'customerId':this.cards[this.nowCardIndex].fkCustomerId}).then((response) => {
            if (response.data.success) {
                this.orgList = response.data.content;
            }else{
              Toast(response.data.errorMessage);
            }
        });
      },
      getOpenId(){
         //alert('nowCardIndex:'+this.nowCardIndex);
         //alert('code:'+this.code);
        this.$http.post('/business/getOpenId', {'orgId':this.cards[this.nowCardIndex].fkOrgId,'code':this.code}).then((response) => {
          if (response.data.success) {
              //alert('openId:'+response.data.content);
              this.saveOpenId(response.data.content);
          }else{
            Toast(response.data.errorMessage);
          }
        });
      },
      getAppId(){
        this.$http.post('/business/getAppId', {'orgId':this.cards[this.nowCardIndex].fkOrgId}).then((response) => {
          if (response.data.success) {
            this.appId = response.data.content;
            if(this.appId){
                let webUrl = config.webUrl + '?nowCardIndex=' + this.nowCardIndex;
                window.location.href = config.proxyUrl+'?appid='+this.appId+'&url='+webUrl+'&state=STATE';
            }else{
              Toast('当前组织未绑定公众号，请联系管理员进行绑定');
            }
          }else{
            Toast(response.data.errorMessage);
          }
        });
      },
      selectCard(index){
        this.nowCardIndex = index;
        this.digShow = false;

        //判断是否需要授权
        if(!this.openId){
          if(!this.$route.query.code || !status){
            this.getAppId();
          }else{
            this.code = this.$route.query.code;
            this.getOpenId();
          }
        }

        this.recharge();
        this.showBusinessList();
        this.showOrgList();
      },
      showCard(){
        this.digShow = true;
      },
      toPayItem(item){
        this.setTransition('move-left');
        this.saveViewParams({'payItem':item});
        this.$router.push('/payItem');
      },
      logOut(){
        this.saveToken('');
        this.saveOpenId('');
        this.saveViewParams({});
        this.$router.push('/login');
      },
      checksub(){
        if(this.$route.query.state == 'STATE' || this.openId ){
          //alert('获取openid');
          this.initCardInfo(true);
        }else{
          if(this.$route.query.state && this.$route.query.code){
            let appIds = this.$route.query.state.split(',');
            this.$http.post('/wxPublic/checkSub', {'appId':appIds.pop(),'code':this.$route.query.code}).then((response) => {
              if (response.data.success) {
                //alert('判断是否关注'+response.data.content.substr);
                if(!response.data.content.substr){//未关注
                  Dialog.alert({
                    message: '请先关注公众号【'+response.data.content.appWxAccessToken.name+'】,才能继续使用.'
                  }).then(() => {
                    window.location.href = response.data.content.appWxAccessToken.subUrl;
                  });  
                }else{//已关注
                    this.$http.post('/wxPublic/getAppId', {'appIds':this.$route.query.state}).then((response) => {
                      if (response.data.success) {
                        //alert('再次获取公众号id进行判断是否关注，'+response.data.content+' appids:'+this.$route.query.state);
                        if(response.data.content){
                          if(response.data.content == 'wx3593eb18fab79fa0'){
                              window.location.href = config.proxyUrl+'?appid='+response.data.content+'&url='+config.webUrl+'&state='+this.$route.query.state+','+response.data.content;
                          }else{
                              window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+response.data.content+'&redirect_uri='+config.webUrl+'&response_type=code&scope=snsapi_base&state='+this.$route.query.state+','+response.data.content+'#wechat_redirect';
                          }
                        }else{
                            //alert('都已关注');
                            this.initCardInfo();
                        }
                      }else{
                        Toast(response.data.errorMessage);
                      }
                    });
                }
              }else{
                Toast(response.data.errorMessage);
              }
            });
          }else{
            this.$http.post('/wxPublic/getAppId', {'appIds':''}).then((response) => {
              if (response.data.success) {
                if(response.data.content){
                  //alert('获取公众号id进行判断是否关注，'+response.data.content+' appids:');
                  if(response.data.content == 'wx3593eb18fab79fa0'){
                      window.location.href = config.proxyUrl+'?appid='+response.data.content+'&url='+config.webUrl+'&state='+response.data.content;
                  }else{
                      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+response.data.content+'&redirect_uri='+config.webUrl+'&response_type=code&scope=snsapi_base&state='+response.data.content+'#wechat_redirect';
                  }
                }else{
                    //alert('无需要关注的公众号');
                    this.initCardInfo(false);
                }
              }else{
                Toast(response.data.errorMessage);
              }
            });
          }
        }  
      },
      ...mapMutations([
        'saveViewParams',
        'saveOpenId',
        'setTransition',
        'saveToken'
      ])
    }
  };
</script>

<style lang="less" scoped>
  .indexBox{
    background-color: rgb(246, 247, 248);
    overflow:scroll;
    overflow-y:hidden;
    overflow-x:hidden;
    min-height: 100%;
    .vanOverlay{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100% + 13px);
         background-color: rgba(255,255,255,0);
    }
    .filter{
      filter:blur(10px);
    }
    .headBox{
      background-color: white;
      height: 250px;
      position: relative;
      .backInfoBox{
          background: linear-gradient(to right, rgb(63,148,244),rgb(19,91,236));
          width: 100%;
          height: 100px;
          border-bottom-right-radius: 5%;
          border-bottom-left-radius: 5%;
      }
      .showMsgInfo{
          position: absolute;
          width: calc(100vw - 30px);
          height: 100px;
          top: 180px;
          left: 15px;
          z-index: 100;
          font-size: 15px;
          display: flex;
          text-align: center;
          align-items: center;  
          justify-content: center;
          .msgContent{
            width: 280px;
          }
      }
      .carInfoBox{
          position: absolute;
          top: 20px;
          left: 15px;
          width: calc(100vw - 30px);
          height: 120px;
          display: flex;
          text-align: center;
          align-items: center;  
          justify-content: flex-start;
          box-shadow: 0 2px 5px rgba(0,0,0,.1);
          border-color: transparent;
          border-radius: 5px;
          font-size: 13px;
          background-repeat:no-repeat;
          background-size:100% 100%;
          .carImg{
            margin-left: 30px;
            .userImgBox{
              overflow:hidden;  
              display: block;  
              width: 70px;  
              height: 70px;  
              border-radius: 50%;  
              border: 1.3px solid #fff;  
              .userImg{
                  width: 70px;  
                  height: 70px; 
              }
            }
          }  
          .carInfo{
            text-align: left;
            padding-left: 40px;
            .info{
                font-size: 14px;
                color: white;
            }
          }
          .switchBox{
              position:absolute;
              top:0px;
              right:0px;
              color: white;
              background: rgb(36, 119, 213);
              border-top-right-radius: 5px;
              border-bottom-left-radius: 5px;
              padding: 3px 15px;
              .style{
                  width: 1em; height: 1em;
                  vertical-align: -0.15em;
                  fill: currentColor;
                  overflow: hidden;
                  font-size: 20px;
                  margin-top: 2px;
              }
          }
        }
      }
      .statiBox{
        width: 100%;
        margin-top: 50px;
        position: relative;
        .title{
          padding-top: 10px;
          padding-left: 15px;
          font-size: 15px;
          font-weight: 700;
        }
        .content{
          display: flex;
          text-align: center;
          align-items: center;
          justify-content: space-between;
          background-color: white;
          padding: 10px 15px;
          .statiItem{
            width: 80px;
            height: 50px;
            display: flex;
            flex-direction: column;
            text-align: center;
            align-items: center;  
            justify-content: center;
            border-radius: 15rpx;
            background-color: white;
            box-shadow: 0 2px 5px rgba(0,0,0,.1);
            border-color: transparent;
            border-radius: 5px;
            font-size: 13px;
            .value{
              padding-top: 3px;
            }
          }
        }
      }
    .payOutBox{
      margin-top: 11px;
      background-color: white;
      padding-left: 15px;
      padding-bottom: 1px;
      position: relative;
      .title{
          padding-top: 10px;
          font-size: 15px;
          margin-bottom: 10px;
          font-weight: 700;
      }
      .payOutItem{
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .payOutLeft{
          text-align: left;
          height: 40px;
          display: flex;
          flex-direction: column;
          .text{
            width: calc(100vw - 140px);
            font-size: 14px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .time{
            color: #969ba3;
            font-size: 13px;
            font-weight: 400;
            margin-top: 2px;
          }
        }
        .payOutRight{
            text-align: right;
            height: 40px;
            width: 110px;
            display: flex;
            color: #969799;
            font-size: 14px;
            padding-right: 15px;
        }
      }
    }
    .payOutShopBox{
      margin-top: 10px;
      background-color: white;
      padding-left: 15px;
      position: relative;
      .title{
          padding-top: 10px;
          font-size: 15px;
          margin-bottom: 10px;
          font-weight: 700;
      }
      .content{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        text-align: center;
        align-items: center;
        justify-content: space-between;
        background-color: white;
        padding: 0 15px 10px 0 ;
        .shopInfo{
          width: 32%;
          height: 50px;
          display: flex;
          flex-direction: column;
          text-align: center;
          align-items: center;  
          justify-content: center;
          border-radius: 15rpx;
          background-color: white;
          box-shadow: 0 2px 5px rgba(0,0,0,.1);
          border-color: transparent;
          border-radius: 5px;
          background: linear-gradient(to right, rgb(63,148,244),rgb(19,91,236));
          margin-bottom: 10px;
          color: white;
          .name{
            font-weight: 700;
            font-size: 15px;
          }
          .value{
             padding-top: 3px;
             font-size: 13px;
          }
        }
        .shopInfo_0{
          width: 32%;
        }
        .shopInfo_1{
          width: 100%;
        }
        .shopInfo_2{
          width: 48%;
        }
      }
    }
    .descBox{
      width: 100%;  
      padding: 30px 0;
      font-size: 13px;
      color: #5c5c5c;
      .descItem{
        width: 100%;
        text-align: center;
        padding-top: 5px;
      }
    }
    .digTagBox{
      max-height: 300px;
      overflow:auto;
      overflow-x:hidden;
      padding: 20px 0 10px 0;
      .digTagInfo{
        div,span{
          text-align: center;
        }
      }
      .card-selected{
        font-weight: bold;
        span{
          color: rgb(19,91,236);
        }
      }
    }
  }
</style>